module MonitoringRules {
    export var module = angular.module("MonitoringRulesModule", ["ui.router", "ui.bootstrap", "frends-utils", "n3-line-chart", "SharedEnvironmentsModule", "ngTagsInput", "ngMessages"])
    export const DEFAULT_ENV_NAME = "Default";

    module.config([
        "$stateProvider", "$locationProvider", "$urlRouterProvider", "$urlMatcherFactoryProvider",
        function ($stateProvider: angular.ui.IStateProvider,
            $locationProvider: ng.ILocationProvider,
            $urlRouterProvider: angular.ui.IUrlRouterProvider,
            $urlMatcherFactoryProvider: ng.ui.IUrlMatcherFactory) {

            // Removes trailing slash before hitting the stateProvider.
            $urlMatcherFactoryProvider.strictMode(false);

            $stateProvider.state("environment", {
                url: "/MonitoringRules/List/:environmentName",
                templateUrl: "MonitoringRulesTemplate",
                controller: "MonitoringRulesController as ruleCtrl",
                resolve: {
                    allEnvironmentNames: ["EnvironmentsDataService",
                        (environmentsDataService: Shared.Environments.EnvironmentsDataService) =>
                            environmentsDataService.all()
                                .then(p => p.map(e => { return { name: e.name, displayName: e.displayName } }))],
                    allPromotedVariables: ["$http",
                        ($http: ng.IHttpService) => $http.get("Process/GetPromotedVariables")
                            .then(result => {
                                if (result.status === 200) {
                                    let data = result.data as Frends.IJsonResponse;
                                    return data.data as string[];
                                }
                                return [];
                            })]
                }
            });

            $locationProvider.html5Mode(true);

            $urlRouterProvider
                .when("/MonitoringRules/List", "/MonitoringRules/List/" + DEFAULT_ENV_NAME);
        }
    ]);
}